import { useState } from 'react'

// eslint-disable-next-line factorial/no-design-system-long-imports
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import { useActionWizard } from 'modules/processes/components/ItemWizard/Actions/ActionProvider'
import {
  EditorContent,
  StateProps,
} from 'modules/processes/components/ItemWizard/Actions/SendCustomEmail/EditorContent'
import { ActionConfigurationHeader } from 'modules/processes/components/ItemWizard/Actions/Steps/FillInformation/Header'
import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'

const initialState = {
  subject: '',
  body: '',
  files: undefined,
}

export const Editor = () => {
  const [state, setState] = useState<StateProps>(initialState)
  const { form } = useFormProvider()

  const { updateConfiguration, getInitialConfiguration, onFiles } = useActionWizard()

  const handleValueChange =
    <K extends keyof StateProps>(key: K) =>
    (value: StateProps[K]) => {
      setState((prevState) => ({ ...prevState, [key]: value }))
    }

  useUnsafeEffect(() => {
    const newState = getInitialConfiguration<StateProps>(initialState)
    setState(newState)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getInitialConfiguration])

  useUnsafeEffect(() => {
    updateConfiguration(state)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])

  const addVariable = (variable: string) => {
    handleValueChange('body')(`${state.body} {{${variable}}}`)
  }

  const updateSubject = (subject: string) => {
    form.setValues({ title: subject })
    handleValueChange('subject')(subject)
  }

  return (
    <>
      <ActionConfigurationHeader
        description={i18n.t('processes.process_settings.actions.automatic_email.description')}
      />
      <EditorContent
        subject={state.subject}
        body={state.body}
        files={state.files}
        updateBody={(val) => handleValueChange('body')(val?.toString() || '')}
        updateSubject={updateSubject}
        onFiles={onFiles}
        addVariable={addVariable}
      />
    </>
  )
}
